module.exports = __webpack_public_path__ + "src/img/link.57e8470a.svg";